import { SHADOW_COLOR, SHADOW_DEPTHS } from "../constants";
export const boxShadow = (depth = "base") => {
    if (typeof depth === "number") {
        return depth > 0 ? `0 ${depth / 2}px ${depth}px 0 ${SHADOW_COLOR}` : "";
    }
    return SHADOW_DEPTHS[depth] ? SHADOW_DEPTHS[depth] : SHADOW_DEPTHS.base;
};
